import React from 'react';
import { Button, Table, Form, FormGroup, ControlLabel, FormControl, HelpBlock, Row, Col } from 'react-bootstrap';

export default class RfidSettingComponent extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    componentWillMount() {
        let reader = {
            name: localStorage.getItem('rfid.name'),
            hostname: localStorage.getItem('rfid.hostname'),
            port: localStorage.getItem('rfid.port'),
            sensitivity: localStorage.getItem('rfid.sensitivity'),
        }
        this.props.assignRfidReader(reader);
    }

    createReader() {
        let reader = {
            name: this.props.rfid.getIn(['entity', 'name']),
            hostname: this.props.rfid.getIn(['entity', 'hostname']),
            port: this.props.rfid.getIn(['entity', 'port']),
            sensitivity: this.props.rfid.getIn(['entity', 'sensitivity']),
        }
        this.props.createReader(reader);
    }

    assignRfidReader(speedway) {
        localStorage.setItem('rfid.name', speedway.name);
        localStorage.setItem('rfid.hostname', speedway.hostname);
        localStorage.setItem('rfid.port', speedway.port);
        localStorage.setItem('rfid.sensitivity', speedway.sensitivity);
        this.props.assignRfidReader(speedway);
    }

    currentSpeedway() {
        let reader = this.props.rfid.get("hostname");
        if (reader) {
            return "目前所選取的 RFID 讀取機為:";
        } else {
            return "目前尚未選取 RFID 讀取機";
        }
    }

    readerHighlight() {
        let reader = this.props.rfid.get("name");
        if (reader) {
            return <span className='highlight-B'>{reader}</span>;
        } else {
            return "";
        }
    }

    handleDelete(speedwayName) {
        let selectedSpeedwayName = localStorage.getItem('rfid.name');
        if (speedwayName === selectedSpeedwayName) {
            alert('RFID reader:' + selectedSpeedwayName + '選取中，無法刪除');
        } else {
            this.props.deleteReaderByName(speedwayName);
        }
    }

    render() {

        // 必填驗證資料
        let name_validationState = null;
        let name_helpBlock = null;
        let hostname_validationState = null;
        let hostname_helpBlock = null;
        let port_validationState = null;
        let port_helpBlock = null;
        let sensitivity_validationState = null;
        let sensitivity_helpBlock = null;
        if (this.props.validation.getIn(['name', 'validationState'])) {
            name_validationState = this.props.validation.getIn(['name', 'validationState']);
        }
        if (this.props.validation.getIn(['name', 'helpBlock'])) {
            name_helpBlock = this.props.validation.getIn(['name', 'helpBlock']);
        }
        if (this.props.validation.getIn(['hostname', 'validationState'])) {
            hostname_validationState = this.props.validation.getIn(['hostname', 'validationState']);
        }
        if (this.props.validation.getIn(['hostname', 'helpBlock'])) {
            hostname_helpBlock = this.props.validation.getIn(['hostname', 'helpBlock']);
        }
        if (this.props.validation.getIn(['port', 'validationState'])) {
            port_validationState = this.props.validation.getIn(['port', 'validationState']);
        }
        if (this.props.validation.getIn(['port', 'helpBlock'])) {
            port_helpBlock = this.props.validation.getIn(['port', 'helpBlock']);
        }
        if (this.props.validation.getIn(['sensitivity', 'validationState'])) {
            sensitivity_validationState = this.props.validation.getIn(['sensitivity', 'validationState']);
        }
        if (this.props.validation.getIn(['sensitivity', 'helpBlock'])) {
            sensitivity_helpBlock = this.props.validation.getIn(['sensitivity', 'helpBlock']);
        }

        return (
            <div>
                <span hidden> RfidSettingComponent </span>

                <h4>{this.currentSpeedway()} {this.readerHighlight()}</h4>
                <br />
                <br />
                <div>
                    <Table striped bordered condensed hover>
                        <caption>選取/更改 RFID 讀取機</caption>
                        <thead>
                            <tr>
                                <th width="10%">&nbsp;</th>
                                <th>名稱</th>
                                <th>hostname</th>
                                <th>port</th>
                                <th>sensitivity</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.rfid.get('readers').map(
                                    (item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <label htmlFor={index} >&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <input type="radio" name="reader" id={index} onClick={(e) => { this.assignRfidReader(item) }} />
                                                            &nbsp;&nbsp;&nbsp;&nbsp;</label>
                                            </td>
                                            <td>
                                                <label htmlFor={index} >{item.name}</label>
                                            </td>
                                            <td>
                                                <label htmlFor={index}  >{item.hostname}</label>
                                            </td>
                                            <td>
                                                <label htmlFor={index}  >{item.port}</label>
                                            </td>
                                            <td>
                                                <label htmlFor={index}  >{item.sensitivity}</label>
                                            </td>
                                            <td key='deleteIcon' style={{ width: 1 }}>
                                                <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442', cursor: 'pointer' }} onClick={(event) => {
                                                    this.handleDelete(item.name);
                                                }} />
                                            </td>
                                        </tr>
                                    )
                                )
                            }
                        </tbody>
                    </Table>
                    <br />
                    <Form horizontal>
                        <Row><Col><p>新增or修改 並選取 RFID 讀取機設定 <span style={{ color: "#FF5733" }}>(KEY => 如果該名稱已存在則會修改資料)</span></p></Col></Row>
                        <Row>
                            <FormGroup controlId="name" validationState={name_validationState}>
                                <Col componentClass={ControlLabel} sm={3}>名稱<span className="text-danger" style={{ marginLeft: 5 }}>*</span></Col>
                                <Col sm={9}>
                                    <FormControl
                                        type="text"
                                        value={this.props.rfid.getIn(['entity', 'name']) == null ? '' : this.props.rfid.getIn(['entity', 'name'])}
                                        onChange={(event) => { this.props.assignReaderName(event.target.value) }}
                                    />
                                    <FormControl.Feedback />
                                    <HelpBlock>{name_helpBlock}</HelpBlock>
                                </Col>
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup controlId="hostname" validationState={hostname_validationState}>
                                <Col componentClass={ControlLabel} sm={3}>hostname<span className="text-danger" style={{ marginLeft: 5 }}>*</span></Col>
                                <Col sm={9}>
                                    <FormControl
                                        type="text"
                                        value={this.props.rfid.getIn(['entity', 'hostname']) == null ? '' : this.props.rfid.getIn(['entity', 'hostname'])}
                                        onChange={(event) => { this.props.assignReaderHostName(event.target.value) }}
                                    />
                                    <FormControl.Feedback />
                                    <HelpBlock>{hostname_helpBlock}</HelpBlock>
                                </Col>
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup controlId="port" validationState={port_validationState}>
                                <Col componentClass={ControlLabel} sm={3}>port<span className="text-danger" style={{ marginLeft: 5 }}>*</span></Col>
                                <Col sm={9}>
                                    <FormControl
                                        type="number"
                                        value={this.props.rfid.getIn(['entity', 'port']) == null ? '' : this.props.rfid.getIn(['entity', 'port'])}
                                        onChange={(event) => { this.props.assignReaderPort(event.target.value) }}
                                    />
                                    <FormControl.Feedback />
                                    <HelpBlock>{port_helpBlock}</HelpBlock>
                                </Col>
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup controlId="sensitivity" validationState={sensitivity_validationState}>
                                <Col componentClass={ControlLabel} sm={3}>sensitivity</Col>
                                <Col sm={9}>
                                    <FormControl
                                        type="number"
                                        max={-30}
                                        min={-70}
                                        value={this.props.rfid.getIn(['entity', 'sensitivity']) == null ? '' : this.props.rfid.getIn(['entity', 'sensitivity'])}
                                        onChange={(event) => { this.props.assignReaderSensitivity(event.target.value) }}
                                    />
                                    <FormControl.Feedback />
                                    <HelpBlock>{sensitivity_helpBlock}</HelpBlock>
                                </Col>
                            </FormGroup>
                        </Row>
                        <Row>
                            <Col style={{ textAlign: "center" }}><Button onClick={(event) => { this.createReader() }} >新增or修改 並選取</Button></Col>
                        </Row>
                    </Form>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/RfidSettingComponent.jsx